<template>
  <div class="enrolling-exam-write-student-list">
    <PlatDataGridSiteUnit grid-id="PeEnrollExamWriteStudent"
                          show-label></PlatDataGridSiteUnit>
  </div>
</template>

<script>
import PlatDataGridSiteUnit from '../../../../../wrapper/grid/PlatDataGridSiteUnit'
export default {
  name: 'EnrollingExamWriteStudentList',
  components: {
    PlatDataGridSiteUnit
  }
}
</script>

<style lang="scss">
  .enrolling-exam-write-student-list {
    height: 100%;
  }
</style>
